import { useState } from 'react';
import { Box } from '@zillow/constellation-10';
import ConnectedLeasesModule from '../ConnectedLeasesModule';
import ConnectedPropertyConditionModule from '../ConnectedPropertyConditionModule';

// TODO: do not call ConnectedPropertyConditionModule
// sometimes I am getting an error, Feature is not supported for this listing
const ConnectedLeaseAndPropertyConditionModule = () => {
  const [isLeasePresent, setIsLeasePresent] = useState(true);

  return (
    <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(12, minmax(0,1fr))', gap: 'tight' }}>
      <Box
        data-testid="LeaseColumn"
        css={{
          gridColumn: { base: '1/13', xl: '1/8' },
          '& > div': { height: { xl: '100%' } },
          '& .ConnectedCard': { height: { xl: '100%' } },
        }}
      >
        <ConnectedLeasesModule setIsLeasePresent={setIsLeasePresent} />
      </Box>
      <Box
        data-testid="PropertyConditionColumn"
        css={{
          gridColumn: { base: '1/13', xl: '8/13' },
          gridRowStart: { base: '2', xl: 'inherit' },
          marginBottom: { base: 'tight', xl: 0 },
          marginTop: { base: 'tight', xl: 0 },
          '& > *': { height: { xl: '100%' } },
          '& .ConnectedCard': { height: { xl: '100%' } },
        }}
      >
        <ConnectedPropertyConditionModule />
      </Box>
    </Box>
  );
};

export default ConnectedLeaseAndPropertyConditionModule;
